import React from 'react'
import HeaderTop from '../../components/HeaderTop/HeaderTop'
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import MapSection from '../../components/MapSection/MapSection'
import Footer from '../../components/footer/Footer'
import Logo from '../../images/logo.svg';
import { PrivacyInfo } from '../../components/PrivacyInfo/PrivacyInfo'

export const PrivacyPolicy = () => {
  return (
    <>
      <HeaderTop />
      <Navbar hclass={'wpo-site-header'} Logo={Logo} />
      <section className={`wpo-breadcumb-area`}>
        <PageTitle pageTitle={'International Logistics'} pagesub={'Privacy Policy'} />
      </section>
      <PrivacyInfo />
      <MapSection />
      <Footer hclass={'wpo-site-footer'} />
    </>
  )
}
